import { Subscription, Observable } from 'rxjs';
import { Component, Input, OnDestroy, SimpleChanges, ViewChild, OnChanges } from '@angular/core';
import { LegacyRouterService, LegacyRouteState } from '@mode/shared/util-js';
import { MatLegacyMenuTrigger } from '@angular/material/legacy-menu';
import { ReportTypes } from '@mode/shared/contract-common';
import { DatasourceDomain } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-metadata-popover',
  templateUrl: './metadata-popover.component.html',
  styleUrls: ['./metadata-popover.component.scss'],
})
export class MetadataPopoverComponent implements OnDestroy, OnChanges {
  // meta data for report
  @Input() userCanEditReport = false;
  @Input() referencedDatasources: DatasourceDomain.Datasource[] = [];
  @Input() numberOfViews = 0;
  @Input() lastEdit = '';
  @Input() lastSuccessfulRun: string | undefined = '';
  // dbt specific data
  @Input() dbtTables: ReportTypes.DbtDetailTable[] | null = null;
  @Input() dbtSourceLastLoadTime: string | null = null;
  @Input() dbtStatus: string | null = null;
  @Input() dbtMessage: string | null = null;
  @Input() dbtDataLoading = true;
  @Input() datasetLastRefreshed = '';
  //
  dbtErrorMessage = 'Error: Data unavailable';
  legacyRouterSub: Subscription;
  routerState: LegacyRouteState | null = null;
  detailsRouteUrl: string | null = null;
  @ViewChild('menuTrigger') menuTrigger!: MatLegacyMenuTrigger;

  constructor(legacyRouterService: LegacyRouterService) {
    this.legacyRouterSub = legacyRouterService.getRouteState().subscribe((routerState: LegacyRouteState) => {
      this.routerState = routerState;

      this.detailsRouteUrl =
        routerState?.url.split('/').pop() === 'details' ? routerState?.url : `${routerState?.url}/details`;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { dbtMessage } = changes;
    if (dbtMessage) {
      this.dbtErrorMessage = dbtMessage.currentValue ? dbtMessage.currentValue : 'Error: Data unavailable';
    }
  }

  ngOnDestroy(): void {
    this.legacyRouterSub.unsubscribe();
  }
}
